import { setData, setName } from "./constants";
import { getEmojiDataFromNative } from "emoji-mart/dist-es/utils";
import { BaseEmoji } from "emoji-mart";

const cache: { [key: string]: BaseEmoji } = {};

export const getEmojiFromNative = (native: string) => {
  let cached = cache[native];
  if (cached === undefined) {
    cached = getEmojiDataFromNative(native, setName, setData);
    cache[native] = cached;
  }

  return cached;
};
